import actions from "./actions";

const initialState = {
  error: null,
  loading: false,
  crawler: {},
  crawlerMeasurement: {},
  crawlerDataCron: {},
};

export default function crawlPlanSaleReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CRAWL_COUPON_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.CRAWL_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        crawler: action.crawler
      };
    case actions.CRAWL_COUPON_ERROR:
      return {
        ...state,
        loading: false,
      };
    case actions.GET_CRAWL_COUPON_REQUEST:
      return {
        ...state,
        crawler: {},
      };
    case actions.GET_CRAWL_COUPON_SUCCESS:
      return {
        ...state,
        crawler: action.crawler,
      };
    case actions.GET_CRAWL_COUPON_ERROR:
      return {
        ...state,
        crawler: {},
        error: action.error,
      };
    case actions.SAVE_DATA_AUTO_CRAWL_COUPON_REQUEST:
      return {
        ...state,
      };
    case actions.SAVE_DATA_AUTO_CRAWL_COUPON_SUCCESS:
      return {
        ...state,
      };
    case actions.SAVE_DATA_AUTO_CRAWL_COUPON_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case actions.GET_DATA_AUTO_CRAWL_COUPON_REQUEST:
      return {
        ...state,
      };
    case actions.GET_DATA_AUTO_CRAWL_COUPON_SUCCESS:
      return {
        ...state,
        crawlerDataCron: action.crawlerData
      };
    case actions.GET_DATA_AUTO_CRAWL_COUPON_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case actions.CRAWL_COUPON_MEASUREMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.CRAWL_COUPON_MEASUREMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        crawlerMeasurement: action.crawlerMeasurement
      };
    case actions.CRAWL_COUPON_MEASUREMENT_ERROR:
      return {
        ...state,
        loading: false,
      };
    case actions.GET_CRAWL_COUPON_MEASUREMENT_REQUEST:
      return {
        ...state,
        crawlerMeasurement: {},
      };
    case actions.GET_CRAWL_COUPON_MEASUREMENT_SUCCESS:
      return {
        ...state,
        crawlerMeasurement: action.crawlerMeasurement,
      };
    case actions.GET_CRAWL_COUPON_MEASUREMENT_ERROR:
      return {
        ...state,
        crawlerMeasurement: {},
        error: action.error,
      };
    default:
      return state;
  }
}
